import XMarkIcon from '@heroicons/react/20/solid/XMarkIcon.js';
import LanguageIcon from 'jsx:../../assets/language-icon.svg';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogClose, DialogContent, DialogHeading } from './dialog';
import { IconButton } from './ui/icon-button';
import { RadioItem, UncontrolledRadioGroup } from './ui/radio-group-list';

const languages = [
  { value: 'en', label: 'Use this website in English' },
  { value: 'mi', label: 'Whakamahia tēnei paetukutuku i te Reo Māori' },
  { value: 'hi', label: 'इस वेबसाइट को हिन्दी में उपयोग करें' },
  { value: 'sm', label: 'Fa‘aaoga lenei uepisaite i le Gagana Sāmoa' },
  { value: 'zh', label: '将本网站切换为中文' },
];

export function ChangeLanguageButton({ size = 'base' }) {
  const [open, setOpen] = useState(false);
  const { i18n, t } = useTranslation();

  const setLang = useCallback(
    (lang) => {
      i18n.changeLanguage(lang);
      setOpen(false);
    },
    [i18n],
  );

  return (
    <>
      <IconButton onClick={() => setOpen(true)} size={size} aria-label={t('selectLanguage')}>
        <LanguageIcon />
      </IconButton>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="Dialog fixed top-0 left-0 size-full overflow-y-auto sm:w-[390px] pt-5 px-4 bg-primary-active text-white">
          <div className="container">
            <DialogHeading className="flex items-start justify-between gap-4 mb-6">
              <LanguageIcon className="size-17.5" aria-label={t('selectLanguage')} role="img" />
              <DialogClose className="hover:text-primary-light" aria-label={t('closeDialog')}>
                <XMarkIcon className="size-6" aria-hidden="true" />
              </DialogClose>
            </DialogHeading>
            <div className="rounded-md bg-white text-body-dark overflow-hidden">
              <UncontrolledRadioGroup
                Component={RadioItem}
                options={languages}
                value={i18n.language}
                onChange={setLang}
              />
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
